export default "__VITE_ASSET__B799xyCc__"